import React from 'react';

export const DetailRow = ({ label, children }: { label: string; children: React.ReactNode }) => {
  return (
    <div className="w-full grid grid-cols-3 items-center justify-between py-4 text-xs text-grey-600">
      <span className="font-primary uppercase">{label}</span>
      <div className="w-full col-span-2 justify-self-start font-sans">{children}</div>
    </div>
  );
};
